import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Table, Alert, Spinner } from 'react-bootstrap';
import { ArrowLeft, Save, Plus, Minus, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getOrdersByStatus, getOrderById, createDeliveryNote } from '../../api/orders';

const CreateDeliveryNote = ({ onCancel, onSuccess }) => {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderItems, setOrderItems] = useState([]);
    const [deliveryItems, setDeliveryItems] = useState([]);
    const [notes, setNotes] = useState('');
    const [loading, setLoading] = useState(false);
    const [orderLoading, setOrderLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    // Charger les commandes qui peuvent être livrées (statut confirmé)
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                setOrderLoading(true);
                // Récupérer les commandes avec statut CONFIRMED
                const response = await getOrdersByStatus('CONFIRMED');
                setOrders(response);
            } catch (err) {
                setError('Erreur lors du chargement des commandes');
                console.error(err);
            } finally {
                setOrderLoading(false);
            }
        };

        fetchOrders();
    }, []);

    console.log('orders recup ', orders)

    // Charger les détails d'une commande spécifique
    // const handleOrderSelect = async (e) => {
    //     const orderId = e.target.value;
    //     if (!orderId) {
    //         setSelectedOrder(null);
    //         setOrderItems([]);
    //         setDeliveryItems([]);
    //         return;
    //     }

    //     console.log('orders selected ', selectedOrder)


    //     try {
    //         setOrderLoading(true);
    //         const response = getOrderById(orderId);
    //         setSelectedOrder(response.data);

    //         // Préparer les produits de la commande
    //         const items = Array.isArray(response.items)
    //         ? response.items.map(item => ({
    //             productId: item.product.id,
    //             productName: item.product.name,
    //             productCode: item.product.productCode,
    //             productUnit: item.product.unit,
    //             quantity: item.quantity,
    //             deliveredQuantity: item.quantity, // Par défaut, on livre tout
    //             notes: ''
    //         }))
    //         : [];


    //         setOrderItems(response.items);
    //         setDeliveryItems(items);
    //     } catch (err) {
    //         setError('Erreur lors du chargement des détails de la commande');
    //         console.error(err);
    //     } finally {
    //         setOrderLoading(false);
    //     }
    // };
    const handleOrderSelect = async (e) => {
        const orderId = e.target.value;
        if (!orderId) {
            setSelectedOrder(null);
            setOrderItems([]);
            setDeliveryItems([]);
            return;
        }

        const selected = orders.find(order => order.id === parseInt(orderId));
        if (selected) {
            setSelectedOrder(selected);
            setOrderItems(selected.items || []); // ou adapte selon ta structure
            // ici, deliveryItems peut être prérempli ou vide selon la logique
            setDeliveryItems(
                (selected.items || []).map(item => ({
                    productId: item.product.id,
                    productName: item.product.name,
                    productCode: item.product.sku,
                    productUnit: item.product.unit,
                    quantity: item.quantity,
                    deliveredQuantity: item.quantity,
                    notes: ''
                }))
            );
            console.log('Commande sélectionnée :', selected); // ici ça fonctionnera
        }
    };


    // Mettre à jour la quantité livrée pour un produit
    const handleQuantityChange = (index, value) => {
        const updatedItems = [...deliveryItems];
        const orderQuantity = updatedItems[index].quantity;

        // Vérifier que la quantité est valide
        let newValue = parseInt(value);
        if (isNaN(newValue) || newValue < 0) {
            newValue = 0;
        } else if (newValue > orderQuantity) {
            newValue = orderQuantity;
        }

        updatedItems[index].deliveredQuantity = newValue;
        setDeliveryItems(updatedItems);
    };

    // Mettre à jour les notes pour un produit
    const handleItemNoteChange = (index, value) => {
        const updatedItems = [...deliveryItems];
        updatedItems[index].notes = value;
        setDeliveryItems(updatedItems);
    };

    // Soumettre le bon de livraison
    const handleSubmit = async (e) => {
        e.preventDefault(); // éviter le rechargement

        try {
            setLoading(true);
            setError('');

            const deliveryNoteData = {
                orderId: selectedOrder.id,
                deliveryDate: new Date().toISOString(),
                notes: notes,
                items: deliveryItems.map(item => ({
                    productId: item.productId,
                    quantity: item.quantity,
                    deliveredQuantity: item.deliveredQuantity,
                    notes: item.notes
                }))
            };

            const response = await createDeliveryNote(deliveryNoteData);

            setSuccess(true);

            setTimeout(() => {
                if (onSuccess) {
                    onSuccess(); // ou onSuccess(response.data) si tu veux lui passer des infos
                }
            }, 2000);

        } catch (err) {
            setError('Erreur lors de la création du bon de livraison');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    // Incrémenter/décrémenter les quantités
    const incrementQuantity = (index) => {
        const updatedItems = [...deliveryItems];
        const orderQuantity = updatedItems[index].quantity;
        if (updatedItems[index].deliveredQuantity < orderQuantity) {
            updatedItems[index].deliveredQuantity += 1;
            setDeliveryItems(updatedItems);
        }
    };

    const decrementQuantity = (index) => {
        const updatedItems = [...deliveryItems];
        if (updatedItems[index].deliveredQuantity > 0) {
            updatedItems[index].deliveredQuantity -= 1;
            setDeliveryItems(updatedItems);
        }
    };

    // Supprimer un produit du bon de livraison
    const removeItem = (index) => {
        const updatedItems = [...deliveryItems];
        updatedItems[index].deliveredQuantity = 0;
        setDeliveryItems(updatedItems);
    };

    return (
        <div>
            {/* <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>Créer un nouveau bon de livraison</h3>
                <Button variant="outline-secondary" onClick={() => navigate('/delivery-notes')}>
                    <ArrowLeft size={16} className="me-1" />
                    Retour
                </Button>
            </div> */}

            {error && <Alert variant="danger">{error}</Alert>}
            {success && (
                <Alert variant="success">
                    Bon de livraison créé avec succès! Redirection en cours...
                </Alert>
            )}

            <Card>
                <Card.Header>
                    <h5 className="mb-0">Informations du bon de livraison</h5>
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Commande à livrer</Form.Label>
                                    <Form.Select
                                        value={selectedOrder ? selectedOrder.id : ''}
                                        onChange={handleOrderSelect}
                                        disabled={orderLoading || loading}
                                        required
                                    >
                                        <option value="">Sélectionner une commande confirmée</option>
                                        {Array.isArray(orders) && orders.map(order => (
                                            <option key={order.id} value={order.id}>
                                                {order.orderNumber} - {order.partner?.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Notes générales</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                        placeholder="Informations supplémentaires sur cette livraison..."
                                        disabled={loading}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {orderLoading && selectedOrder && (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                                <p>Chargement des détails de la commande...</p>
                            </div>
                        )}

                        {selectedOrder && !orderLoading && deliveryItems.length > 0 && (
                            <>
                                <h5 className="mb-3">Produits à livrer</h5>
                                <Table bordered responsive>
                                    <thead>
                                        <tr>
                                            <th>Référence</th>
                                            <th>Produit</th>
                                            {/* <th>Quantité commandée</th> */}
                                            <th>Quantité à livrer</th>
                                            <th>Notes</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {deliveryItems.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.productCode}</td>
                                                <td>{item.productName}</td>
                                                {/* <td className="text-center">{item.quantity} {item.productUnit || 'unités'}</td> */}
                                                <td style={{ width: '200px' }}>
                                                    <div className="d-flex align-items-center">
                                                        <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            onClick={() => decrementQuantity(index)}
                                                            disabled={loading || item.deliveredQuantity <= 0}
                                                        >
                                                            <Minus size={16} />
                                                        </Button>
                                                        <Form.Control
                                                            type="number"
                                                            value={item.deliveredQuantity}
                                                            onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                            onWheel={(e) => e.target.blur()}
                                                            min="0"
                                                            max={item.quantity}
                                                            className="mx-2 text-center"
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            onClick={() => incrementQuantity(index)}
                                                            disabled={loading || item.deliveredQuantity >= item.quantity}
                                                        >
                                                            <Plus size={16} />
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={item.notes}
                                                        onChange={(e) => handleItemNoteChange(index, e.target.value)}
                                                        placeholder="Notes sur ce produit"
                                                        disabled={loading}
                                                    />
                                                </td>
                                                <td className="text-center">
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => removeItem(index)}
                                                        disabled={loading}
                                                    >
                                                        <Trash2 size={16} />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>
                        )}

                        <div className="d-flex justify-content-end mt-4">
                            <Button
                                variant="secondary"
                                className="me-2"
                                onClick={() => onCancel()}
                                disabled={loading}
                            >
                                Annuler
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={loading || !selectedOrder || orderLoading}

                            >
                                {loading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        Création en cours...
                                    </>
                                ) : (
                                    <>
                                        <Save size={16} className="me-1" />
                                        Créer le bon de livraison
                                    </>
                                )}
                            </Button>

                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default CreateDeliveryNote;